import { render, staticRenderFns } from "./BaseGrid.vue?vue&type=template&id=199241aa"
import script from "./BaseGrid.vue?vue&type=script&lang=js"
export * from "./BaseGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports